"use client";

//////////////////////////////////////////////////////
////////////////////// NOTES /////////////////////////
//////////////////////////////////////////////////////

// NOTE this method of polyfilling can only be gauranteed to work for code that is not a side effect of module loading
// e.g. code inside of components or a store's method will get polyfilled. If  it's part of the global scope of the module
// We cannot guarantee this will load before it runs.

// There are disadvantages to this, but it's also faster than adding this script to the <head> with "beforeInteractive"

// We are going to need something more robust in the event we need to get more advanced with this.
// For now this is sufficient.

//////////////////////////////////////////////////////
//////////// Format for adding a polyfill ////////////
//////////////////////////////////////////////////////

// <Name of the method>
// Description of why it's being added

/////////////////////////////////////////
//////////// BEGIN POLYFILLS ////////////
/////////////////////////////////////////

// AbortSignal.timeout
// As of 08-08-25 We have users on CriOS who are running older verisons of Chrome
// e.g. v125 and cannot run models because of this. This can be removed at some point, perhaps a year from now.
function polyfillAbortSignalTimeout() {
  if (!AbortSignal.timeout) {
    AbortSignal.timeout = function timeout(ms) {
      const controller = new AbortController();
      setTimeout(() => controller.abort(), ms);
      return controller.signal;
    };
  }
}
//////////////////////////////////////////
//////////// CREATE POLYFILLS ////////////
//////////////////////////////////////////

polyfillAbortSignalTimeout();

//////////////////////////////////////////
///// CONTEXT TO AVOID TREESHAKING ///////
//////////////////////////////////////////

function PolyfillContext({ children }) {
  return children;
}

export default PolyfillContext;
